/* ============================================================================
   WWF-CUSTOM FILE | CL-043 | Added 2026-10-17 | Wild + Well-Fed rebrand
   CL-051 (2026-10-17): fix, subscription was added as one-time (form.id
   clobbered by the variant input); button shows the subscription price.
   ----------------------------------------------------------------------------
   Subscribe & Save choice inside Palo Alto's Quick view (the popout that
   opens from a product card).

   Why: the Bold Subscriptions widget is an app block and does not load in
   Quick view. Bold creates standard Shopify selling plans, so this script
   reads them from the product's data (/products/<handle>.js) and adds its own
   picker. No Palo Alto file is edited.

   What shoppers see (under the size and grind options):
     - One-time purchase / Subscribe & Save 10%, each with its price
     - Delivery frequency menu (Monthly, Every 2 Months, Every 3 Months),
       shown only when Subscribe & Save is picked
     - a short note (free shipping over $30, pause or cancel anytime)
   One-time purchase is selected by default, like the Bold blocks.

   How it adds a subscription: a hidden selling_plan field is tied to the
   Quick view add-to-cart form. It is only switched on when Subscribe & Save
   is picked, so one-time purchases are unchanged.

   Who sees it: same rule as the Bold widget (CL-007): US shoppers who are
   not B2B customers, and only for products that have a selling plan. The
   rule and the wording come from window.wwfQvSub, set in
   snippets/wwf-head.liquid (CL-043 marker). Edit the wording there.

   Styles: assets/wwf-custom.css section 11.
   ========================================================================= */
/* WWF-CUSTOM START | CL-062 | 2026-10-18 | "Full details" link in Quick view (all shoppers)
   Quick view is a quick add. This adds a clear link to the full product page
   right under the title and price (the title itself also links there).
   Runs for every shopper (the subscription picker below only runs for US
   retail). */
(function () {
  'use strict';
  function addLink(root) {
    if (root.querySelector('[data-wwf-qv-details]')) return;
    var titleLink = root.querySelector('.popup-quick-view__title a[href]');
    var href = titleLink ? titleLink.getAttribute('href') : null;
    var viewBtn = root.querySelector('a.popup-quick-view__view-button[href]');
    if (!href && viewBtn) href = viewBtn.getAttribute('href');
    if (!href) return;
    var heading = titleLink ? (titleLink.closest('.popup-quick-view__title') || titleLink) : null;
    var price = root.querySelector('.popup-quick-view__content > .product__price-and-badge');
    var anchor = price || heading;
    if (!anchor || !anchor.parentNode) return;
    var a = document.createElement('a');
    a.href = href;
    a.setAttribute('data-wwf-qv-details', '');
    a.className = 'wwf-qv-details';
    a.textContent = 'View full details, ingredients & testing →';
    a.style.cssText = 'display:inline-block;margin-top:8px;font-size:13px;text-decoration:underline;text-underline-offset:3px;';
    anchor.parentNode.insertBefore(a, anchor.nextSibling);
  }
  function scan() {
    var roots = document.querySelectorAll('.popup-quick-view__wrapper');
    Array.prototype.forEach.call(roots, addLink);
  }
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; scan(); }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
/* WWF-CUSTOM END | CL-062 */

(function () {
  'use strict';

  var cfg = window.wwfQvSub || {};
  if (!cfg.eligible) return;

  var cache = {};
  var busy = false;

  /* ---------- helpers ---------- */

  function formatMoney(cents) {
    var fmt = cfg.moneyFormat || (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var n = Number(cents) || 0;
    function withDelims(num, decimals, thousands, decimal) {
      var fixed = (num / 100).toFixed(decimals);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimals ? decimal : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(n, 0, '.', ',');
        default: return withDelims(n, 2, ',', '.');
      }
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function handleFrom(root) {
    var link = root.querySelector('.popup-quick-view__title a[href], a.popup-quick-view__view-button[href]');
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function loadProduct(handle) {
    if (!cache[handle]) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      cache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' }
      }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    return cache[handle];
  }

  /* ---------- build ---------- */

  function build(formInner, form, product) {
    var groups = product.selling_plan_groups || [];
    var plans = [];
    groups.forEach(function (g) { (g.selling_plans || []).forEach(function (p) { plans.push(p); }); });
    if (!plans.length) return null;

    var pct = '';
    var adj = plans[0].price_adjustments && plans[0].price_adjustments[0];
    if (adj && adj.value_type === 'percentage') pct = adj.value;
    var subLabel = (cfg.subText || 'Subscribe & Save ||percent||%');
    subLabel = pct !== '' ? subLabel.replace('||percent||', pct) : subLabel.replace(/\s*\|\|percent\|\|%?/, '');

    var required = !!product.requires_selling_plan;
    var uid = 'wwfqv' + Math.random().toString(36).slice(2, 8);

    var box = document.createElement('div');
    box.className = 'wwf-qv-sub';
    box.setAttribute('data-wwf-qv-sub', '');
    box.innerHTML =
      '<fieldset class="wwf-qv-sub__options">' +
        '<legend class="wwf-qv-sub__legend">Purchase options</legend>' +
        (required ? '' :
        '<label class="wwf-qv-sub__option">' +
          '<input type="radio" name="' + uid + '-mode" value="once" checked data-wwf-qv-mode>' +
          '<span class="wwf-qv-sub__label">' + esc(cfg.onceText || 'One-time purchase') + '</span>' +
          '<span class="wwf-qv-sub__price" data-wwf-qv-price="once"></span>' +
        '</label>') +
        '<label class="wwf-qv-sub__option">' +
          '<input type="radio" name="' + uid + '-mode" value="subscribe"' + (required ? ' checked' : '') + ' data-wwf-qv-mode>' +
          '<span class="wwf-qv-sub__label">' + esc(subLabel) + '</span>' +
          '<span class="wwf-qv-sub__price" data-wwf-qv-price="sub"></span>' +
        '</label>' +
      '</fieldset>' +
      '<div class="wwf-qv-sub__freq" data-wwf-qv-freq hidden>' +
        '<label class="wwf-qv-sub__freq-label" for="' + uid + '-plan">Delivery frequency</label>' +
        '<select id="' + uid + '-plan" class="wwf-qv-sub__select" data-wwf-qv-plan>' +
          plans.map(function (p) { return '<option value="' + esc(p.id) + '">' + esc(p.name) + '</option>'; }).join('') +
        '</select>' +
      '</div>' +
      (cfg.note ? '<p class="wwf-qv-sub__note">' + esc(cfg.note) + '</p>' : '');

    // Hidden field tied to the add-to-cart form (sent only when switched on).
    var field = document.createElement('input');
    field.type = 'hidden';
    field.name = 'selling_plan';
    field.value = plans[0].id;
    field.disabled = true;
    field.setAttribute('data-wwf-qv-input', '');
    // WWF-CUSTOM CL-051: read the id attribute. form.id returns the form's
    // <input name="id"> (the variant field), not the form's own id.
    var formId = form.getAttribute('id');
    if (formId) field.setAttribute('form', formId);
    box.appendChild(field);

    box._wwf = { product: product, form: form };
    formInner.appendChild(box);
    return box;
  }

  /* ---------- state ---------- */

  function currentVariant(box) {
    var p = box._wwf.product;
    var input = box._wwf.form.querySelector('[name="id"]');
    var id = input ? String(input.value) : '';
    for (var i = 0; i < p.variants.length; i++) {
      if (String(p.variants[i].id) === id) return p.variants[i];
    }
    return p.variants[0];
  }

  function sync(box) {
    if (!box._wwf || !document.body.contains(box)) return;
    var v = currentVariant(box);
    var allocs = {};
    (v.selling_plan_allocations || []).forEach(function (a) { allocs[String(a.selling_plan_id)] = a; });
    var hasPlans = Object.keys(allocs).length > 0;

    var once = box.querySelector('[data-wwf-qv-mode][value="once"]');
    var sub = box.querySelector('[data-wwf-qv-mode][value="subscribe"]');
    var select = box.querySelector('[data-wwf-qv-plan]');
    var field = box.querySelector('[data-wwf-qv-input]');
    var freq = box.querySelector('[data-wwf-qv-freq]');

    // A size or grind without a subscription falls back to one-time.
    if (sub && once) {
      sub.disabled = !hasPlans;
      if (sub.disabled && sub.checked) once.checked = true;
    }
    if (select) {
      Array.prototype.forEach.call(select.options, function (o) { o.disabled = hasPlans && !allocs[o.value]; });
      var sel = select.options[select.selectedIndex];
      if (sel && sel.disabled) {
        for (var i = 0; i < select.options.length; i++) {
          if (!select.options[i].disabled) { select.selectedIndex = i; break; }
        }
      }
    }

    var subscribe = !!(sub && sub.checked && hasPlans);
    if (freq) freq.hidden = !subscribe;
    if (field) {
      if (select) field.value = select.value;
      field.disabled = !subscribe;
      // Re-attach if the theme redrew the form with a new id.
      var form = box._wwf.form;
      if (!document.body.contains(form)) {
        var root = box.closest('.popup-quick-view__wrapper');
        var fresh = root && root.querySelector('form[data-product-form]');
        if (fresh) { box._wwf.form = fresh; }
      }
      // WWF-CUSTOM CL-051: always re-point the field at the form's id attribute.
      var fid = box._wwf.form.getAttribute('id');
      if (fid && field.getAttribute('form') !== fid) field.setAttribute('form', fid);
    }

    var oncePrice = box.querySelector('[data-wwf-qv-price="once"]');
    var subPrice = box.querySelector('[data-wwf-qv-price="sub"]');
    if (oncePrice) oncePrice.innerHTML = esc(formatMoney(v.price));
    if (subPrice) {
      var a = select ? allocs[select.value] : null;
      if (!a) { var k = Object.keys(allocs)[0]; a = k ? allocs[k] : null; }
      subPrice.innerHTML = a ? esc(formatMoney(a.price)) : '';
    }

    // WWF-CUSTOM CL-051: show the price being added on the Add to Cart button
    // (subscription price when Subscribe & Save is picked).
    var qvRoot = box.closest('.popup-quick-view__wrapper') || document;
    var btnPrice = qvRoot.querySelector('[data-add-to-cart] [data-product-price]');
    if (btnPrice) {
      var ba = null;
      if (subscribe) { ba = select ? allocs[select.value] : null; if (!ba) { var bk = Object.keys(allocs)[0]; ba = bk ? allocs[bk] : null; } }
      btnPrice.innerHTML = esc(formatMoney(ba ? ba.price : v.price));
    }
  }

  function syncAll() {
    document.querySelectorAll('[data-wwf-qv-sub]').forEach(sync);
  }

  function syncSoon() {
    // Let the theme update the chosen variant first.
    setTimeout(syncAll, 80);
    setTimeout(syncAll, 400);
  }

  /* ---------- find Quick views ---------- */

  function scan() {
    busy = false;
    var inners = document.querySelectorAll('.popup-quick-view__form-inner:not([data-wwf-qv-done])');
    Array.prototype.forEach.call(inners, function (inner) {
      var root = inner.closest('.popup-quick-view__wrapper') || inner.parentNode;
      var form = root && root.querySelector('form[data-product-form]');
      var handle = root && handleFrom(root);
      if (!form || !handle) return; // not fully drawn yet; the next change re-scans
      inner.setAttribute('data-wwf-qv-done', '');
      loadProduct(handle).then(function (product) {
        if (!product || !document.body.contains(inner)) return;
        var box = build(inner, form, product);
        if (box) sync(box);
      });
    });
  }

  function queueScan() {
    if (busy) return;
    busy = true;
    (window.requestAnimationFrame || setTimeout)(scan);
  }

  new MutationObserver(queueScan).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') queueScan();
  else document.addEventListener('DOMContentLoaded', queueScan);

  /* ---------- events ---------- */

  document.addEventListener('change', function (e) {
    var box = e.target && e.target.closest && e.target.closest('[data-wwf-qv-sub]');
    if (box) { sync(box); return; }
    if (document.querySelector('[data-wwf-qv-sub]')) syncSoon();
  });

  document.addEventListener('click', function (e) {
    if (!document.querySelector('[data-wwf-qv-sub]')) return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-add-to-cart], button[type="submit"]')) syncAll();
    else if (t.closest('.popup-quick-view__wrapper')) syncSoon();
  }, true);
})();
